import { createContext } from "react";

const ApplicationListContext = createContext<any>({});

export default ApplicationListContext;
